/* eslint-disable react/no-unescaped-entities */
/* CONFILEX — Définitions communes (référencées par CGU, CGV, Confidentialité)
 * Cf. point 4 du cahier des charges juridique de février 2026.
 */
import React from "react";

const Term = ({ term, children, testId }) => (
  <div className="mb-4" data-testid={testId}>
    <dt className="font-semibold text-[#0B3A2A]">{term}</dt>
    <dd className="text-slate-700 leading-relaxed mt-1">{children}</dd>
  </div>
);

export const DefinitionsContent = () => (
  <>
    <h2 className="font-serif text-2xl text-[#0B3A2A] mb-3">Définitions</h2>
    <p className="text-slate-600 italic mb-8">
      Les termes suivants s'appliquent dans l'ensemble du cadre contractuel de CONFILEX
      (CGU, CGV, Politique de confidentialité, Politique de cookies et documents annexes).
    </p>

    <dl className="space-y-2">
      <Term term="Confilex" testId="def-confilex">
        Désigne la plateforme numérique proposant des outils d'analyse documentaire,
        de structuration de dossiers, de préparation d'échanges amiables, de recherche
        de professionnels et de mise en relation, exploitée par la société éditrice
        identifiée dans les Mentions légales.
      </Term>

      <Term term="Utilisateur" testId="def-utilisateur">
        Désigne toute personne physique ou morale qui accède à Confilex ou utilise l'un
        de ses services, qu'elle dispose ou non d'un compte.
      </Term>

      <Term term="Professionnel" testId="def-professionnel">
        Désigne notamment un avocat ou tout autre membre d'une profession réglementée
        référencé sur Confilex, titulaire ou non d'un compte et d'un profil revendiqué.
      </Term>

      <Term term="Données officielles" testId="def-donnees-officielles">
        Désigne les informations professionnelles provenant d'une source publique ou
        institutionnelle, notamment l'Annuaire national des avocats publié par le
        Conseil national des barreaux sur data.gouv.fr.
      </Term>

      <Term term="Données déclaratives" testId="def-donnees-declaratives">
        Désigne les informations ajoutées directement par un Professionnel après la
        création ou la revendication de son profil (présentation, photo, disponibilité,
        domaines d'intervention déclarés, langues, modalités de rendez-vous, etc.).
      </Term>

      <Term term="Profil revendiqué" testId="def-profil-revendique">
        Désigne une fiche professionnelle dont le rattachement au Professionnel concerné
        a été vérifié par Confilex, sur la base d'un justificatif d'identité professionnelle.
      </Term>

      <Term term="Mise en relation" testId="def-mise-en-relation">
        Désigne la fonctionnalité permettant à un Utilisateur de prendre contact avec un
        Professionnel ou de lui transmettre une demande ou un dossier.
      </Term>

      <Term term="Dossier" testId="def-dossier">
        Désigne l'ensemble des documents, renseignements, messages, chronologies,
        analyses et autres éléments déposés ou générés dans Confilex par l'Utilisateur
        ou pour son compte.
      </Term>

      <Term term="Analyse assistée par intelligence artificielle" testId="def-analyse-ia">
        Désigne le traitement technique permettant de détecter, organiser, résumer ou
        signaler certains éléments dans les documents transmis. Cette analyse constitue
        un <strong>outil d'assistance</strong> et <strong>non un avis juridique
        personnalisé</strong> délivré par un avocat ou tout autre professionnel réglementé.
      </Term>
    </dl>

    <div className="mt-8 rounded-lg border border-[#C9A961]/40 bg-[#C9A961]/5 p-4 text-sm text-slate-700">
      <p>
        <strong className="text-[#0B3A2A]">Portée juridique.</strong> Ces définitions
        s'imposent à toutes les parties : Utilisateurs, Professionnels référencés (avec ou
        sans profil revendiqué) et Confilex. En cas de doute d'interprétation d'un terme
        au sein des CGU, CGV, Politique de confidentialité ou de toute autre page légale,
        c'est la définition ci-dessus qui prévaut.
      </p>
    </div>
  </>
);

export default DefinitionsContent;
